module.exports = __webpack_public_path__ + "static/media/tachometer-alt.9adcd059.svg";